export const TTL_FOR_MACHINE_STATUS_UPDATED = 60 * 1000;
